import { useEffect } from "react";
import { useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../enums/modalId";
import { RootState } from "../../../../redux/store/store";

export const useModalOpenerForMyPaOrders = () => {
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );
  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
  }, [openedModalId]);
  return { openedModalId, metaData };
};
